/**
 * Created by intellicar-rinas on 9/8/17.
 */
import $http from "../helpers/$http";
import { API_HOST } from "../constants/constants";
import apiHelper from "../helpers/apiHelper";

const UserAPIs = {
  login: (body) => {
    return $http
      .post(API_HOST + "/gettokensinglesignon", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  verifyToken: (body) => {
    return $http
      .post(API_HOST + "/verifytoken", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  googleLogin: (body) => {
    return $http
      .post(API_HOST + "/getgoogletokennew", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  impersonate: (body) => {
    return $http
      .post(API_HOST + "/api/impersonate", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  verifyEmail: (body) => {
    return $http
      .post(API_HOST + "/api/verifyemailbydomain", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  requestUserAccess: (body) => {
    return $http
      .post(API_HOST + "/api/requestuseraccess", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getEmailOtp: (body) => {
    return $http
      .post(API_HOST + "/api/otp/getemailotp", {
        re_version: "v3_web",
        ...body,
      })
      .then(apiHelper.validateResponseBasic, apiHelper.validateFailure);
  },

  resetPassword: (body) => {
    return $http
      .post(API_HOST + "/api/user/resetpassword", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  validatePassword: (body) => {
    return $http
      .post(API_HOST + "/api/user/validatepassword", body)
      .then(apiHelper.validateResponseBasic, apiHelper.validateFailure);
  },

  getList: (body, uid) => {
    return $http
      .post(API_HOST + "/api/user/listwitheditdeleteperm", body, {}, uid)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  changePassword: (body) => {
    return $http
      .post(API_HOST + "/api/user/changepassword", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getInfo: (body) => {
    return $http
      .post(API_HOST + "/api/user/getinfo", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  updateInfo: (body) => {
    return $http
      .post(API_HOST + "/api/user/updateinfo", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  getMyGroups: (body) => {
    return $http
      .post(API_HOST + "/api/user/getmygroups", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  gpsHistory: (body) => {
    return $http
      .post(API_HOST + "/api/user/gpshistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  phoneBatteryHistory: (body) => {
    return $http
      .post(API_HOST + "/api/user/phonebatteryhistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },

  cellInfoHistory: (body) => {
    return $http
      .post(API_HOST + "/api/user/cellinfohistory", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
  getPoiList: (body) => {
    return $http
      .post(API_HOST + "/api/poi/list", body)
      .then(apiHelper.validateResponse, apiHelper.validateFailure);
  },
};

export default UserAPIs;
